import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { EmisoresListComponent } from './emisores-list.component';
import { EmisoresService } from './emisores.service';
import { IEmisor } from './emisor';
// import * as myGlobals from './../global';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-emisores',
  templateUrl: './emisores.component.html',
  styleUrls: ['./emisores.component.sass']
})
export class EmisoresComponent implements OnInit, OnDestroy, AfterViewInit {
  emisores: IEmisor[] = [];
  errorMessage = '';
  currentPg = 1;
  // collection: any[] = this.emisores;

  constructor(
    public service: EmisoresService,
    private parent: EmisoresListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    // $('#menu-catalogos').click();
    $('a[rel=emisores]').addClass('selected');
  }

  newEmisor(): void {
    this.parent.showEditEmisor = false;
    this.parent.showEmisores = false;
    this.parent.showAddEmisor = true;
  }

  ngOnInit(): void {
    this.spinner();
    this.service
      .getEmisores()
      .subscribe(res => (this.emisores = res), err => this.httpErrorValidator.validateError(err));
  }

  edit(elemento, index: number) {
    this.parent.editnumber = elemento.id;
    this.parent.showEmisores = false;
    this.parent.showAddEmisor = false;
    this.parent.showEditEmisor = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=emisores]').removeClass('selected');
  }
}
